import { useContext, useEffect, useState } from 'react';
import { RadioGroup } from '@headlessui/react';
import { useFormikContext } from 'formik';
import RadioOption from 'src/components/PropertyType/RadioOption';
import FormContext from 'src/contexts/settlement-context';

export default function RadioButton({ RADIO_INFO }) {
  const { formData, setDisableNext } = useContext(FormContext);
  const form = useFormikContext();

  const [selected, setSelected] = useState(() => {
    switch (formData?.type) {
      case 'real':
        return RADIO_INFO[0];
      case 'personal':
        return RADIO_INFO[1];
      case 'greenbelt':
        return RADIO_INFO[2];
      case 'vehicle':
        return RADIO_INFO[3];
      default:
        return '';
    }
  });

  useEffect(() => {
    form.setFieldValue('type', selected.value);
    setDisableNext(!selected);
    // prevent infinite loop
    // eslint-disable-next-line
  }, [selected, setSelected]);

  return (
    <div className="flex items-center justify-center ">
      <RadioGroup onChange={setSelected} value={selected}>
        <RadioGroup.Label className="sr-only">Property type</RadioGroup.Label>
        <div className="my-auto grid grid-cols-1 gap-4 md:grid-cols-2">
          {RADIO_INFO.map((item, index) => (
            <RadioOption key={index} value={item} checked={item === selected} />
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
